module.exports = __webpack_public_path__ + "img/d955865.png";